import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DeviceActiveSyncsEffects } from './devices-active-syncs.effects';
import { deviceActiveSyncsReducer } from './devices-active-syncs.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('deviceActiveSyncsState', deviceActiveSyncsReducer),
    EffectsModule.forFeature([DeviceActiveSyncsEffects]),
  ],
  providers: [],
})
export class DeviceActiveSyncsStoreModule {}
